import { appConfig } from "src/config";

export const DEEP_LINK_DOMAIN =
  appConfig.NOOM_ENV === "production"
    ? "https://link.noom.com/app"
    : "https://link-test.noom.com/app";

export const NATIVE_DEEP_LINK_DOMAIN =
  appConfig.NOOM_ENV === "production"
    ? "noom://noom.app.link"
    : "noomtest://noom.app.link";

/**
 * Builds a deep link URL for the Noom mobile app
 * @param params - Query parameters to add to the URL (e.g., { open: 'LOGIN', email: 'user@example.com' })
 * @param useNativeDeepLink - Whether to use native deep link domain instead of web deep link domain
 * @returns The complete deep link URL
 *
 * @example
 * Basic deep link
 * buildDeepLink(); // https://link.noom.com/app
 *
 * Basic native deep link
 * buildDeepLink({}, true); // noom://noom.app.link
 *
 * Deep link with single parameter
 * buildDeepLink({ open: 'RECIPES' }); // https://link.noom.com/app?open=RECIPES
 * buildDeepLink({ open: 'RECIPES' }, true); // noom://noom.app.link?open=RECIPES
 *
 * Deep link with multiple parameters
 * buildDeepLink({
 *   open: 'LOGIN',
 *   authType: 'FACEBOOK'
 * }); // https://link.noom.com/app?open=LOGIN&authType=FACEBOOK
 * buildDeepLink({
 *   open: 'LOGIN',
 *   authType: 'FACEBOOK'
 * }, true); // noom://noom.app.link?open=LOGIN&authType=FACEBOOK
 *
 * Deep link with email
 * buildDeepLink({ email: 'user@example.com' }); // https://link.noom.com/app?email=user@example.com
 * buildDeepLink({ email: 'user@example.com' }, true); // noom://noom.app.link?email=user@example.com
 */
export const buildDeepLink = (
  params: Record<string, string> = {},
  useNativeDeepLink = false
) => {
  const deepLinkDomain = useNativeDeepLink
    ? NATIVE_DEEP_LINK_DOMAIN
    : DEEP_LINK_DOMAIN;
  const queryString = new URLSearchParams(params).toString();
  return `${deepLinkDomain}${queryString ? `?${queryString}` : ""}`;
};

/**
 * Default deep link for app login
 */
export const DEFAULT_APP_LOGIN_DEEPLINK = buildDeepLink({ open: "LOGIN" });
